// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionTitle_wrapper__1ts4O","title":"SectionTitle_title__YvSvs","actions":"SectionTitle_actions__+EvPh"};